import React, { useEffect } from 'react'
import { useController, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useJiraIntegrationPage } from './jira-integration-page.provider'
import { SingleSelectComboboxObject } from '../../../../legacy-design-system/combobox'
import {
  useIssueTypesQuery,
  UseIssueTypesQueryProps
} from '../api/use-issue-types'
import { IssueType } from '../api/shared'
import { JiraFormFieldTypes } from './jira-form-field-types'
import { transformFormDataToBugtrackerRequest } from '../../bugtrackers/api/build-api-payload-bugtracker-credentials'
import { JiraIntegrationForm } from './jira-form-schema'

interface UseRefreshIssueTypeStateProps extends UseIssueTypesQueryProps {
  issueType?: string | IssueType
  updateIssueType: (...event: any[]) => void
}

export const useLoadIssueTypes = ({
  organizationUuid,
  projectKey,
  bugtrackerRequest,
  issueType,
  updateIssueType
}: UseRefreshIssueTypeStateProps): IssueType[] | undefined => {
  const { issueTypes } = useIssueTypesQuery({
    organizationUuid,
    bugtrackerRequest,
    projectKey
  })

  useEffect(() => {
    if (issueType && issueTypes?.length) {
      const issueTypeMatch = issueTypes.find((issueTypeRecord) => {
        // @ts-ignore
        // eslint-disable-next-line eqeqeq
        return issueTypeRecord.id == issueType
      })

      updateIssueType(issueTypeMatch || issueTypes[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issueTypes])

  return issueTypes
}

export const DefaultIssueTypeField = () => {
  const { formatMessage } = useIntl()

  const {
    state: { organizationUuid }
  } = useJiraIntegrationPage()
  const { getValues, watch, setValue } = useFormContext<JiraIntegrationForm>()

  const selectedProject = watch(JiraFormFieldTypes.PROJECT)

  const {
    field: { onChange, value }
  } = useController({ name: JiraFormFieldTypes.ISSUE_TYPE })

  const issueTypes = useLoadIssueTypes({
    organizationUuid,
    projectKey:
      (typeof selectedProject === 'object' ? selectedProject.key : '') ?? '',
    bugtrackerRequest: transformFormDataToBugtrackerRequest(getValues),
    issueType: value,
    updateIssueType: onChange
  })

  // we need to clear integrations when this changes
  const handleChange = (val) => {
    setValue('integration', false)
    onChange(val)
  }

  return (
    <SingleSelectComboboxObject<IssueType>
      label={formatMessage({
        id: 'title_integrationsSettings_defaultIssueType'
      })}
      items={[{ items: issueTypes ?? [] }]}
      value={
        //  Only load the UI once the full data structure has been found & set, not just the string ID on initial load
        typeof value === 'object' ? value : undefined
      }
      onChange={handleChange}
      itemToString={(item) => item.name}
      disabled={selectedProject === undefined}
      itemToID={(item) => item.name}
    />
  )
}
